import { StatusUserEnum } from 'consts/data';

class UserModel {
  static initialProfileUser(userInfo) {
    const {
      info: infoUser = {},
      phone,
      country,
      email,
      username,
      role,
      company,
      companyDesc,
      companyPhone,
      industry,
      statusName,
      createDate,
      linkAccounts,
    } = userInfo || {};
    const { extraInfo } = infoUser;

    return {
      //* Personal information
      myAccountAddress1: infoUser?.address1 || '',
      myAccountAddress2: infoUser?.address2 || '',
      myAccountTimezone: infoUser?.timeName || '',
      myAccountFirstname: infoUser?.firstname || '',
      myAccountLastname: infoUser?.lastname || '',
      myAccountCity: infoUser?.city || '',
      myAccountState: infoUser?.state || '',
      myAccountZip: infoUser?.zip || '',
      myAccountGender: infoUser?.gender || '',

      myAccountPhone: phone,
      myAccountCountry: country,
      myAccountTxn: '',
      myAccountCompany: company,
      myAccountCompanyDesc: companyDesc,
      myAccountCompanyPhone: companyPhone,
      myAccountIndustry: industry,
      myAccountNoCustomers: '',

      myAccountEmail: email,
      myAccountUsername: username,
      myAccountRole: role,
      myAccountStatus: statusName,
      myAccountCreateDate: createDate,
      myAccountLinkAccounts: linkAccounts,

      //* Billing information
      myBillingAddress: extraInfo?.billingAddress || '',
      myBillingName: extraInfo?.billingName || '',
      myBillingCountry: extraInfo?.billingCountry || '',
      myBillingRegNo: extraInfo?.billingRegNo || '',
      myBillingVatNo: extraInfo?.billingVatNo || '',

      myBillingIBAN: extraInfo?.billingIBAN || '',
      myBillingBIC: extraInfo?.billingBIC || '',
      myBillingIntermediaryBIC: extraInfo?.billingIntermediaryBIC || '',
      myBillingBank: extraInfo?.billingBank || '',
      myBillingBankAddress: extraInfo?.billingBankAddress || '',
      myEntityName: extraInfo?.entityName || '',
    };
  }

  static initialPaymentSetting(userInfo) {
    const { autoRecharge, rechargeVolume } = userInfo || {};

    return {
      //* Payment - autoRecharge | rechargeVolume
      autoRecharge: autoRecharge === 1,
      rechargeVolume: rechargeVolume,
    };
  }

  static initialAutoOptimization(userInfo) {
    const settings = userInfo?.settings || {};

    return {
      autoOptimization: {
        autoOp: settings?.autoOpActive || false,
        testSize: settings?.autoOpTestSizeLap1 || '',
        pausedMin: settings?.autoOpPausedMinLap1 || '',

        threshold: settings?.autoOpThresholdLap1 || '',
        thresholdPerReply: settings?.autoOpThresholdPerReplyLap1 || '',
        thresholdPerBlock: settings?.autoOpThresholdPerBlockLap1 || '',
        thresholdPerOptout: settings?.autoOpThresholdPerOptoutLap1 || '',

        autoOpLap2: settings?.autoOpLap2Active || false,
        autoOpLap2CreativeSize: settings?.autoOpLap2CreativeSize || '',
        testSizeLap2: settings?.autoOpTestSizeLap2 || '',
        pausedMinLap2: settings?.autoOpPausedMinLap2 || '',

        thresholdLap2: settings?.autoOpThresholdLap2 || '',
        thresholdPerReplyLap2: settings?.autoOpThresholdPerReplyLap2 || '',
        thresholdPerBlockLap2: settings?.autoOpThresholdPerBlockLap2 || '',
        thresholdPerOptoutLap2: settings?.autoOpThresholdPerOptoutLap2 || '',

        thresholdPerConvertor: settings?.autoOpThresholdPerConvertorLap1 || '',
        thresholdPerConvertor2: settings?.autoOpThresholdPerConvertorLap2 || '',

        // Rev/per mil minutes
        thresholdRevenuePerMilMessage: settings?.autoOpThresholdRevenuePerMilMessage ?? '',
        thresholdRevenuePerMilMinute: settings?.autoOpThresholdRevenuePerMilMinute ?? '',
        thresholdRevenuePerDeliveredCall: settings?.autoOpThresholdRevenuePerDeliveredCall ?? '',
        thresholdCallRate: settings?.autoOpThresholdCallRate ?? '',
        thresholdRoi: settings?.autoOpThresholdRoi ?? '',

        thresholdRevenuePerMilMessageLap2: settings?.autoOpThresholdRevenuePerMilMessageLap2 ?? '',
        thresholdRevenuePerMilMinuteLap2: settings?.autoOpThresholdRevenuePerMilMinuteLap2 ?? '',
        thresholdRevenuePerDeliveredCallLap2:
          settings?.autoOpThresholdRevenuePerDeliveredCallLap2 ?? '',
        thresholdCallRateLap2: settings?.autoOpThresholdCallRateLap2 ?? '',
        thresholdRoiLap2: settings?.autoOpThresholdRoiLap2 ?? '',
      },
    };
  }

  static checkStatusOfUser(statusName) {
    return {
      isActive: statusName === StatusUserEnum.Active,
      isInactive: statusName === StatusUserEnum.Inactive,
      isPending: statusName === StatusUserEnum.Pending,
      isSuspended: statusName === StatusUserEnum.Suspended,
      isBanned: statusName === StatusUserEnum.Banned,
    };
  }

  static findRouteInRoutesInfo(routeId, routesInfo = []) {
    return (routesInfo || [])?.find((route) => toString(routeId) === toString(route.id)) || {};
  }

  static mappingLabelBillingInfo(field) {
    const mapping = {
      billingAddress: 'Address',
      billingName: 'Name',
      billingCountry: 'Country',
      billingRegNo: 'Reg. No.',
      billingVatNo: 'VAT. No.',
      billingIBAN: 'International Bank Account Number',
      billingBIC: 'BIC (Business Identifier Code) / SWIFT CODE',
      billingIntermediaryBIC: 'Intermediary BIC',
      billingBank: 'Bank',
      billingBankAddress: 'Bank address',
      myEntityName: 'Entity name',
      entityName: 'Entity name',
    };

    return mapping?.[field] || '';
  }
}

export default UserModel;
